<!--
*  TTTech nerve-ui-components
*  Copyright(c) 2022. TTTech Industrial Automation AG.
*
*  ALL RIGHTS RESERVED.
*
*  Usage of this software, including source code, netlists, documentation,
*  is subject to restrictions and conditions of the applicable license
*  agreement with TTTech Industrial Automation AG or its affiliates.
*
*  All trademarks used are the property of their respective owners.
*
*  TTTech Industrial Automation AG and its affiliates do not assume any liability
*  arising out of the application or use of any product described or shown
*  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
*  make changes, at any time, in order to improve reliability, function or
*  design.
*
*  Contact Information:
*  support@tttech-industrial.com
*
*  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
*
* -->
<script>
// eslint-disable-next-line import/no-unresolved
import { VDialog } from 'vuetify/lib';

export default {
  name: 'NerveDialog',
  extends: VDialog,
};
</script>

<style lang="scss">
.v-dialog {
  min-width: 460px !important;
}
.v-dialog > .v-card > .v-card__title {
  font-size: 22px !important;
  padding: 30px 30px 40px 30px !important;
  justify-content: center !important;
  white-space: pre-wrap;
  word-break: break-word;
}
.v-dialog > .v-card > .v-card__text {
  padding: 0px 30px 0px 30px !important;
  font-size: 18px !important;
  justify-content: center !important;
}
.v-dialog > .v-card > .v-card__actions {
  padding: 30px 30px !important;
  justify-content: end !important;
  margin: 0px;
}
.v-card__text {
  text-align: center !important;
}
</style>
